import api from "../api/axiosConfig";

const deliveryService = {
  getSales: () => api.get("/delivery/sales"),
  getSale: (saleId) => api.get(`/delivery/sales/${saleId}`),
  start: (saleId) => api.post("/delivery", { saleId }),
  getMine: () => api.get("/delivery"),
  complete: (deliveryId, file) => {
    const formData = new FormData();
    formData.append("evidence", file);
    return api.post(`/delivery/${deliveryId}/evidence`, formData);
  },
};

export default deliveryService;
